import AddQuizForm from "../../../components/Admin/Quiz/AddQuizForm";
import Navbar from "../../../components/Navbar";

export default function AddQuiz() {
  return (
    <>
      <Navbar />
      <section className="py-6 bg-primary">
        <div className="mx-auto max-w-full px-5 lg:px-20">
          <AddQuizForm />
        </div>
      </section>
    </>
  );
}
